import type {ContentBlocksFragment} from '@/modules/foundation/sanity/content-blocks/query';
import type {KeyedArray} from '@/modules/foundation/shared/types';

import type {ArticleDetails} from '../../shared/types';
import {ARTICLE_IN_CARD_FRAGMENT, articleInCardFragmentToArticleDetails} from '../query';

import type {BLOCK_TYPE_ARTICLE_LIST_SELECTION} from './constants';

export const ARTICLE_LIST_SELECTION_FRAGMENT = `//groq
	...,
	articles[]-> {
		${ARTICLE_IN_CARD_FRAGMENT},
	}
`;

export type ArticleListSelectionFragmentType = Extract<
	ContentBlocksFragment[number],
	{_type: typeof BLOCK_TYPE_ARTICLE_LIST_SELECTION}
>;

export const articleListFromArticleListSelectionSection = (
	section: ArticleListSelectionFragmentType,
): KeyedArray<ArticleDetails> => {
	const articles: KeyedArray<ArticleDetails> = [];

	if (!section.articles?.length) {
		return articles;
	}

	for (const articleInCard of section.articles) {
		if (articleInCard) {
			const article = articleInCardFragmentToArticleDetails(articleInCard);
			if (article) {
				articles.push({
					_key: articleInCard._id,
					...article,
				});
			}
		}
	}

	return articles;
};
